export namespace VRGALLERY.OBJECT{
    export const FLOOR_TYPE = 1;
    export const WALL_TYPE = 2;
    export const TYPES:{[key:number]:string} = {
        1: "FLOOR",
        2 : "Wall"
    };
    export const BUMP_SCALES:{[key:number]:number} = {
        1: 0.3,
        2 : 0.05
    };
}

export namespace VRGALLERY.CAPTIONS{
    export const TITLES: Array<string> = [
        "『Mona Lisa』, by Leonardo da Vinci",
        "『Young Woman with a Water Pitcher』, by Johannes Vermeer",
        "『Sunflowers』, by Vincent van Gogh",
        "『富嶽三十六景　神奈川沖浪裏』, by 葛飾 北斎"
    ];
    export const DESCRIPTIONS: Array<string> = [
        "『モナ・リザ』（伊: La Gioconda、仏: La Joconde）は、イタリアの美術家レオナルド・ダ・ヴィンチよって、1503年頃から約3年の歳月をかけて書かれたとされる肖像画である。キャンパスではなく、77cm×53cmのポプラ板に油彩で描かれており、「世界でもっとも知られた、もっとも見られた、もっとも書かれた、もっとも歌われた、もっともパロディ作品が作られた美術作品」といわれている. \r\nまた、同氏により描かれた『サルバトール・ムンディ』は「男性版モナリザ」とも呼ばれ、2017年に美術品としては史上最高額(2019年12月時点)の約4億5030万ドル(約510億円)で落札された。",
        "『水差しを持つ女』は17世紀オランダの巨匠ヨハネス・フェルメールによって描かれた風俗画のひとつである。\r\n光の差し込む窓際に一人の女性が描かれた構図は、フェルメールの代表的な構図で、いくつか作品で共通して見られる代表的な特徴である。\r\n女性の衣服を彩る鮮やかな青色は「フェルメールブルー」と呼ばれ、17世紀では金よりも貴重な鉱石であったとされる「ラピスラズリ」を原料としている。\r\nフェルメールの現存する作品数は約37点（真贋が疑問視されている作品を含む）と非常に少なく、芸術的な価値に加えて希少価値の高い画家と言える。",
        "『ゴッホのひまわり』と言えば「花瓶に活けられたひまわり」をモチーフにした油彩画7点があまりにも有名だが、ゴッホは生涯を通して様々な構図でのひまわりを描いている。本作もそのひとつで1887年に描かれた作品であり、メトロポリタン美術館に所蔵されている。",
        "『富嶽三十六景』は江戸時代の浮世絵師、葛飾北斎による木版画集のひとつで、富士山のある景色を描いた36図のシリーズ作品である。\r\n初めは題名の通りの36図が出版されたが、その後人気のために追加で10図が出版され、合計で46図のシリーズ作品となった。\r\n『神奈川沖浪裏』は富嶽三十六景を含めた葛飾北斎の作品中でも代表作とされ、世界中で高い評価と多くの芸術家への影響を与えている。\r\n日本では幾つかの美術館で所蔵されており、摺られた時期によって微妙な色合いの違いを楽しむことができる。",
    ];
}

export namespace HTTP.STATUS{
    export const DEFAULT                : number = 10000;
    export const OK                     : number = 200;
    export const BAD_REQUEST            : number = 400;
    export const NOT_FOUND              : number = 404;
    export const SERVER_ERROR           : number = 500;
    export const TEMPORARY_NOT_AVAILABLE: number = 503;
    export const MESSAGE: { [key: number]: string } = {
        400: "リクエスト情報が正しくありません。",
        404: "指定されたリソースが見つかりませんでした。",
        500: "サーバ内でエラーが発生しました。",
        503: "一時的にサーバが利用できない状態です。",
        10000: "エラーが発生しました。"
    };
}